import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core';
import { MatLabel } from '@angular/material/form-field';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { FormsModule } from '@angular/forms';
import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';
import { CommonModule } from '@angular/common';
import { jkLib } from '../../services/jkCommon';

@Component({
    selector: 'app-jktext',
    templateUrl: './jktext.component.html',
    styleUrls: ['./jktext.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule,
    CommonModule,
     // MaterialModule,
      JkfieldlabelComponent],
})
export class JktextComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'jktext';
  override flexStyle:any = { display: 'flex'};
  readonly labelPlacement = input('fixed'); // "end" ｜ "fixed" ｜ "floating" ｜ "stacked" ｜ "start"
  //@Input() width:number = 200;
  readonly dataType = input<string>('text'); // string,text, number, datefield
  _value: string = '';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set value(v:string){
    if(v === undefined || v === null){
      v = '';
      return;
    }
      this._value = v;
  }
  get value(): string{
    return this._value;
  }
  readonly valueChange = output<string>();
  onValueChange(newValue: Event) {
    if (newValue && newValue.target) {
      // this._value = newValue.target.value; 也可以
      //this.value = (newValue.target as HTMLInputElement).value;
    }
    if(this.valueChange)
      this.valueChange.emit(this.value);
  }

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set valueN(v: number){
      this._value = v.toString();
  }
  get valueN(): number{
    return Number(this._value);
  }
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  set valueD(v: string){
    this._value = jkLib.dateField2Display(v);
  }
  get valueD(): string{
    let result;
    if(this.dataType() === 'datefield'){
      result = jkLib.display2Datefield(this._value,'/');
    }else{
      result = this._value;
    }
    return result;
  }

  constructor() {
    super();
   }

  override ngOnInit() {
    super.ngOnInit();
  }

}
